export enum NotificationType {
  PreautorisationUpdate = 'PREAUTORISATION',
  CapaciteModifiee = 'ONE_SHOT_CAPACITE'
}
